/**
 *
 *  Useful as a callback for asynch operations.
 *
 */

var sw = require('js/lib/sw');
var $ = require('js/sw-jquery/sw-jquery');

sw.on('sw-trigger-noty', function(data) {
  var displayedNoty = $.noty.get(data.messageOptions.id);
  if (displayedNoty) {
    displayedNoty.setText(data.message);
  } else {
    sw.notifications.displayNoty(data.message, {
      addClass: data.messageOptions.addClass,
      timeout: data.messageOptions.timeout,
      closeWith: data.messageOptions.closeWith,
      layout: data.messageOptions.layout,
      type: data.messageOptions.type,
      id: data.messageOptions.id
    });
  }
});
